export default __webpack_public_path__ + "static/media/awc-grey.8e41ff33.svg";